import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardPageComponent } from './components/card-page/card-page.component';
import { CardComponent } from './components/card/card.component';
import { SharedModule } from '../shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    declarations: [CardPageComponent, CardComponent],
    imports: [CommonModule, SharedModule, NgbModule],
    exports: [CardPageComponent, CardComponent],
})
export class CardModule {}
